export default {
  contractActivity: {
    contractActivity: {
      title: ({ plural }) => plural(["Activité", "Activités"]),
      type: {
        professional: "Entreprise",
        pedagogic: "Formation",
      },
      tabs: {
        description: "Description",
        document: "Annexes",
      },
      status: {
        complete: "Complète",
        to_complete: "À compléter",
      },
      context: "Contexte",
      description: "Tâches réalisées",
      difficulties_encountered: "Difficultés & solutions",
      results_obtained: "Résultats obtenus",
      analysis_and_learning: "Analyse & apprentissage",
      tools: "Outils & technologies",
      skills: "Compétences liées",
      autonomy_complexity: "Autonomie & complexité",
      missions: "Missions liées",
      no_activities: "Aucune activité n'est définie sur ce contrat.",
      no_activities_filtered: "Aucune activité ne correspond au filtre sélectionné.",
      relatedSkills: {
        launch_analysis: "Lancer l'analyse",
        relaunch_analysis: "Relancer l'analyse",
        badge_default: "Analyse IA des compétences",
        badge_with_date: ({ named }) => `Référentiel ${named("code")} — Analyse effectuée le ${named("date")}`,
        badge_no_date: ({ named }) => `Référentiel ${named("code")}`,
        no_activity_id: "Enregistrez d'abord l'activité pour accéder aux compétences.",
        no_analysis: "Cliquez sur « Lancer l'analyse » pour identifier les compétences mobilisées dans cette activité.",
        ia_disclaimer:
          "<strong>L'IA suggère des compétences, elle ne les valide pas.</strong><br>C'est votre maître d'apprentissage qui les validera en certifiant l'activité.",
        analysing: "Analyse en cours, veuillez patienter…",
        ai_analysis: "Analyse IA de correspondance entre l'activité et le bloc de compétence",
        summary_title: "Analyse IA de correspondance de l'activité avec les compétences",
        validated: "Validé",
        to_validate: "À valider",
        validate_all_proposals: "Valider la relation activité/compétences",
        add_block_picker_title: "Ajouter manuellement des blocs de compétences",
        add_block_confirm: "Ajouter les blocs sélectionnés",
        selected_skills_count: ({ named }) =>
          `${named("count")} compétence${named("count") <= 1 ? "" : "s"} sélectionnée${named("count") <= 1 ? "" : "s"}`,
        collapsed_selected_skills_heading: "Compétences sélectionnées",
        skill_status_selected: "Compétence sélectionnée",
        skill_status_validated: "Compétence validée",
      },
      annexes: {
        count: ({ named }) => `${named("count")} annexe(s) jointe(s) à cette activité`,
        technical_documents: "Documents techniques",
        screenshots_photos: "Captures d'écran & photos",
        empty: "Aucune annexe jointe à cette activité.",
      },
    },
    import: {
      button: "Importer un rapport",
      confirm_title: "Déposez votre rapport d'activité",
      confirm_text:
        "L'IA lit votre document, le découpe en activités distinctes et pré-remplit les champs structurés. Elle organise votre contenu, elle n'en invente pas.",
      dropzone_hint: "PDF uniquement",
      launch: "Lancer l'analyse",
      validation_notice: "Vous validerez et corrigerez chaque activité avant tout enregistrement.",
      loading_title: "Analyse en cours",
      step_reading_title: "Lecture du document",
      step_reading_subtitle: "Extraction du texte et de la structure",
      step_sections_title: "Découpage en sections",
      step_sections_subtitle: "Titres, ruptures thématiques",
      step_detection_title: "Détection des activités",
      step_detection_subtitle: "Verbes d'action — ce que l'alternant a réellement fait",
      step_extraction_title: "Extraction des informations",
      step_extraction_subtitle: "Missions, périodes, tâches, outils, sources",
      completed: "Analyse terminée",
      error_title: "L'analyse n'a pas pu aboutir",
      failed: "L'analyse du rapport a échoué. Veuillez la relancer.",
      retry: "Relancer l'analyse",
      result_title: "Validation",
      result_empty: "Aucune activité n'a pu être détectée dans ce rapport.",
      result_count: ({ plural, named }) =>
        plural([`${named("count")} activité détectée`, `${named("count")} activités détectées`]),
      result_sentence: "Nous avons identifié {performed} et {observed}.",
      performed_count: ({ plural, named }) =>
        plural([`${named("count")} activité réalisée`, `${named("count")} activités réalisées`]),
      observed_count: ({ plural, named }) =>
        plural([`${named("count")} activité observée`, `${named("count")} activités observées`]),
      ai_summary_title: "Ce que l'IA a trouvé",
      review_notice:
        "Vérifiez les informations extraites pour chaque activité. Vous pourrez les corriger et les compléter à tout moment après validation.",
      counter_activities: "Activités",
      counter_excluded: "Sections écartées",
      activities_list: "Activités détectées dans le rapport",
      ai_comment_title: "Commentaire IA",
      status_to_check: "À vérifier",
      status_validated: "Validée",
      not_specified: "Non précisé dans le rapport",
      to_complete: "À compléter après validation",
      level_not_specified: "Non précisé",
      no_mission: "Aucune mission rattachée pour le moment",
      validate: "Valider cette activité",
      validate_label: ({ named }) => `Valider l'activité « ${named("name")} »`,
      unvalidate: "Annuler la validation de cette activité",
      unvalidate_label: ({ named }) => `Annuler la validation de l'activité « ${named("name")} »`,
      announcement_validated: ({ named }) =>
        `Activité « ${named("name")} » validée. ${named("count")} activité(s) validée(s).`,
      announcement_unvalidated: ({ named }) =>
        `Activité « ${named("name")} » non validée. ${named("count")} activité(s) validée(s).`,
      publish: ({ plural, named }) =>
        plural([`Créer ${named("count")} activité validée`, `Créer ${named("count")} activités validées`]),
      publish_success: ({ plural, named }) =>
        plural([
          `${named("count")} activité importée depuis le rapport et ajoutée au livret`,
          `${named("count")} activités importées depuis le rapport et ajoutées au livret`,
        ]),
      badge_ia: "Importée IA",
    },
  },
};
